import CustomerDeatils from "../../components/Customer/customerDetails";
import BasicCostInfo from "../../components/Customer/BasicCostInfo";
import CoustRelat from "../../components/Customer/coustRelat";
import SerAdvisory from "../../components/Customer/serAdvisory";
import SerAdvisCompile from "../../components/Customer/serAdvisCompile";
import UnitOne from "../../components/Customer/unitOne"
export default  {
  path:'customers',
  component:CustomerDeatils,
  children:[
    // {
    //   path: '/',
    //   redirect:'basicinfo/:id'
    // },
    {
      path: 'basicinfo/:id/:category',
      component:BasicCostInfo
    },
    {
      path:'relations/:id/:category',
      component:CoustRelat
    },
    {
      path:'serviceAdvisory/:id/:category',
      component:SerAdvisory
    },
    {
      path:'serviceAdvisoryCompile/:id/:category',
      component:SerAdvisCompile
    },
    {
      path:'unitOne/:id/:category',
      component: UnitOne
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/clientManagement/index.js